@if (totalCount) {
  <div class="full-width paginator-container flex align-center justify-center"
    [ngClass]="{'small': small}"
    >
    @if (!small) {
      <div
        class="margin-right-small">
        {{'PAGINATION.ITEM_FOR_PAGE' | translate}}
      </div>
    }
    <select class="margin-right-small"
      [(ngModel)]="selectedSize"
      (ngModelChange)="onChangeSize()">
      @for (item of sizes; track item) {
        <option
        [value]="item">{{item}}</option>
      }
    </select>
    <div class="margin-right">/ {{totalCount}}</div>
    <div class="margin-right-small no-wrap">
      {{'PAGINATION.PAGE' | translate}}
    </div>
    <input class="margin-right-small"
      type="number"
      [(ngModel)]="currentPage"
      (change)="onChangePageIndex($event)" />
      @if (totalCount != null) {
        <div class="no-wrap"
          >
          {{'PAGINATION.OF' | translate}} {{pagesTotal}}
        </div>
      }
      <button rippleEffect
        class="btn btn-icon"
        [disabled]="pageIndex <= 0"
        (click)="onChangePage(pageIndex - 1)">
        <span data-feather="chevron-left"></span>
      </button>
      <button rippleEffect
        class="btn btn-icon"
        [disabled]="pageIndex >= pagesTotal - 1"
        (click)="onChangePage(pageIndex + 1)">
        <span data-feather="chevron-right"></span>
      </button>
    </div>
  }
